<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-money-check-dollar"></i></div>
      <div>
        Frais par classe
        <div class="page-title-subheading">Types de frais appliqués à chaque classe</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
<div class="container">
    <div class="d-flex justify-content-end">
        <div class="form-group ms-auto">
                        <label for=""> <strong>Rechercher:</strong> </label>
                        <input placeholder="Rechercher..." class="form-control form-control-sm" type="text" name="search_text" [(ngModel)]="search_text">
                    </div>
    </div>
    <div class="row">
        <div class="col-12 col-md-6 mb-3" *ngFor="let d of data | sampleSearch:search_text:'inscription_files'">
            <div class="card card-body">
               <div class="d-flex justify-content-between">
<div class="me-2">
                        <button *ngIf="buttonsPermission?.add" type="button" class="btn btn-danger btn-sm" (click)="add(addContent)">
                            <i class="fa-solid fa-plus me-2" aria-hidden="true"></i>Affecter un frais
                            </button>
                    </div>
                                    <h5 class="text-center fw-bold">
                    {{d?.name}}

                </h5>
                <button (click)="add(addContent,d)" type="button" class="btn btn-sm btn-primary px-5 rounded-0">Ajouter</button>

               </div>
                <h5 class="text-center mb-3 fw-bold">Type de frais</h5>
                <table class="table table-sm">
                    <tbody>
                        <tr class="" *ngFor="let tf of d.type_fees">
                            <td><span>{{tf?.name}}</span></td>
                            <td>
                                <i  (click)="delete(tf.id)"  class=" fa fa-trash text-success" style="cursor: pointer;"></i>         
                            </td>
                        </tr>
                    </tbody>
                </table>
                   
            </div>
        </div>
    </div>
    <pagination-controls 
    [maxSize]="9"
    [directionLinks]="true"
    [autoHide]="true"
    [responsive]="true"
    [previousLabel]="'Previous'"
    [nextLabel]="'Next'"
    [screenReaderPaginationLabel]="'Pagination'"
    [screenReaderPageLabel]="'page'"
    [screenReaderCurrentLabel]="'You\'re on page'">
    </pagination-controls>
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Associer un type de frais à une classe</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class="form-group col-12 mb-3">
                <label for="">Choisir le type de frais <span class="text-danger ml-2">(*)</span></label>
                <ng-select name="type_fee_id" id="" ngModel>
                    <ng-option selected disabled></ng-option>
                    <ng-option *ngFor="let c of type_fees" [value]="c.id">{{c.name}}</ng-option>
                </ng-select>
            </div>
        
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

